import { render, staticRenderFns } from "./pipe.vue?vue&type=template&id=5f85ed3d&scoped=true"
import script from "./pipe.vue?vue&type=script&lang=js"
export * from "./pipe.vue?vue&type=script&lang=js"
import style0 from "./pipe.vue?vue&type=style&index=0&id=5f85ed3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f85ed3d",
  null
  
)

export default component.exports